import { intl } from "LocaleWrapper";
import { Tag, TagSize } from "@cofano/cck";
import { Contact } from "types/commons";

const ContactRoleTypeTags = ({ contact }: { contact: Pick<Contact, "id" | "contactRoleTypes"> }) => {
	return (
		<div style={{ display: "flex", flexWrap: "wrap" }}>
			{contact.contactRoleTypes && contact.contactRoleTypes.length !== 0 && contact.contactRoleTypes.map(r => (
				<span style={{ margin: 2 }}><Tag size={TagSize.SMALL} color="#D18427" text={intl.formatMessage({ id: r })} /></span>
			))}
		</div>
	);
};

export default ContactRoleTypeTags;
